import AutoQuery from 'servicestack/auto-query/auto-query'
import ServiceBus from 'servicestack/service-bus'
import BasicController from 'servicestack/basic.controller'
import $session from 'servicestack/session'
import resolve from 'ioc/resolve'
import modals from 'webmodals/modals'
import EntityNotePrompt from 'servicestack/notes/entity-note-prompt'


function EntityNotePromptDirective($window, $parse, $session) {
    // Introduce custom elements for IE8
    $window.document.createElement('entity-note-prompt');
    return {
        scope: false,
        link: function (scope, element, attr) {
            var onEntityNoteSaved = attr.onEntityNoteCreated || attr.onEntityNoteSaved;

            var $targets = (attr.entityNotePromptClickSelector ? element.find(attr.entityNotePromptClickSelector) : element);
            $targets.on('click', e => {
                var model = scope.$eval(attr.entityNotePrompt || attr.ngModel || attr.entity || attr.note) || {
                    entityId: attr.entityId,
                    entityType: attr.entityType,
                    note: attr.note
                };
                if (!model.note) {
                    model.note = {
                        noteText: '',
                        createdBy: $session.userName,
                        createdOn: new Date()
                    }
                }
                if (model.entityId && model.entityType) {
                    model.note.tags = {
                        EntityId: model.entityId,
                        EntityType: model.entityType
                    };
                }
                EntityNotePrompt.open({ title: attr.title, scope, attr, element, $targets, model }).then(
                    (saved) => {
                        if (attr.onEntityNoteSaved) {
                            $parse(attr.onEntityNoteSaved)(scope, { $saved: saved })
                        }
                    }, () => {
                        if (attr.onDismissed) {
                            $parse(attr.onDismissed)(scope, {})
                        }
                    });
            });
        }
    }
};

export default EntityNotePromptDirective;